import React from 'react';
import { Reveal } from './Reveal';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="w-full bg-black px-4 py-20" data-id="element-79">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-80">
        <div className="mb-8" data-id="element-81">
          <Countdown data-id="element-82" />
        </div>

        <span className="inline-block rounded-full border border-gold/40 bg-gold/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-gold" data-id="element-83">
          🏆 Pack complet
        </span>

        <div className="mt-8 overflow-hidden rounded-3xl border border-gold/40 bg-ink-card p-8 sm:p-10" data-id="element-84">
          <h2 className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-85">
            🏆 Le protocole clinique en 4 étapes™ — Pack complet
          </h2>
          <p className="mt-2 text-sm font-semibold text-white/70" data-id="element-86">
            1 Volume Principal + 5 Outils Complémentaires
          </p>

          <div className="mt-6 flex items-baseline justify-center gap-3" data-id="element-87">
            <span className="text-2xl text-white/40 line-through" data-id="element-88">85€</span>
            <span className="font-display text-6xl text-gold sm:text-7xl" data-id="element-89">
              27€
            </span>
          </div>
          <div className="mt-3 inline-block rounded-full bg-grass/20 px-5 py-2 text-base font-extrabold tracking-wide text-grass sm:text-lg" data-id="element-90">
            ÉCONOMISEZ 85€
          </div>

          <div className="mt-8" data-id="element-91">
            <CTAButton data-id="element-92">🚀 Je veux accéder au kit maintenant — 27€</CTAButton>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-93">
            <span data-id="element-94">🔒 Paiement sécurisé</span>
            <span data-id="element-95">⚡ Accès immédiat</span>
            <span data-id="element-96">🛡️ Garantie 7 jours</span>
            <span data-id="element-97">💳 Carte · PayPal · Virement</span>
          </div>
        </div>
      </Reveal>
    </section>;
}